<template>
    <div class="process-view">
        <van-nav-bar
                fixed
                title="项目流程"
                left-arrow
                @click-left="$router.go(-1)">
        </van-nav-bar>
        <div class="hhb-view">
            <van-steps direction="vertical">
                <van-step
                        v-for="(item,index) in process"
                        :key="index">
                    <div class="step-warp">
                        <div v-text="item.statusDescription"></div>
                        <div v-text="item.creationTime"></div>
                    </div>
                </van-step>
            </van-steps>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'process-view',
        data() {
            return {
                process: []
            };
        },
        methods: {
            requestData() {
                this.request({
                    url: "/v1.0/Project/getProjectProccesList",
                    method: "get",
                    params: {
                        projectId: this.getId,
                    },
                }).then((res) => {
                    this.process = res.data || [];
                }).catch(() => {
                });
            }
        },
        computed: {
            getId() {
                return this.$route.query.id;
            }
        },
        created() {
            this.requestData();
        }
    }
</script>

<style lang="scss" scoped>
    .process-view {

    }
</style>